import React, {useState} from 'react';
import {Badge, DialogTitle, IconButton, } from "@material-ui/core";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import {useSelector} from "react-redux";
import {bbFindEntityWithinPortfolioOrSelf, bbFormattedDateString, isCurrentUserMemberOf} from "../../../util/bbHelpers";
import BBIconQuickViewMagnifying from "../../../assets/bbCustomIcons/BBIconQuickViewMagnifying";
import {Card, Dialog, DialogActions, DialogContent} from "@mui/material";
import {Button, Col, Row} from "reactstrap";
import CloseIcon from "@material-ui/icons/Close";
import BRSocialTestEventsTable from "./BRSocialTestEventsTable";
import BBIconPaperClipThin from "../../../assets/bbCustomIcons/BBIconPaperClipThin";
import BBIconHyperlink from "../../../assets/bbCustomIcons/BBIconHyperlinkRound";
import IdentityScopeToggle from "./IdentityScopeToggle";

const BRSocialTestEventsModal = ({testId = null, cycleId=null, testObj=null,}) =>{

    const [open, setOpen] = useState(false);

    const {customers, customerInView} = useSelector(({customer}) => customer);

    const {portfolios, entityInView} = useSelector(({breachrisk}) => breachrisk);
    const {authUser} = useSelector(({auth}) => auth);

    const isAdmin = isCurrentUserMemberOf(authUser, "admin");

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const customer = customers ? customers[customerIdToUse] : null;

    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);

    const lastCycle = myEntity ? myEntity.last_cycle : null
    const lastCycleId = myEntity && myEntity.settings && myEntity.settings.last_cycle_id;
    const cycleIdToUse = cycleId ? cycleId : lastCycleId;

    // console.log("here's the test object passed to this detail modal", testObj);

    const socialTest = testObj
        ? testObj
        : myEntity
        && myEntity.cycles
        && myEntity.cycles[cycleIdToUse]
        && myEntity.cycles[cycleIdToUse].social
        && myEntity.cycles[cycleIdToUse].social.socialTests
        && myEntity.cycles[cycleIdToUse].social.socialTests[testId];

    const identity = myEntity
        && myEntity.cycles
        && socialTest
        && socialTest.tested_identity
        && socialTest.tested_identity.id
        && myEntity.cycles[cycleIdToUse]
        && myEntity.cycles[cycleIdToUse].social
        && myEntity.cycles[cycleIdToUse].social.identities
        && myEntity.cycles[cycleIdToUse].social.identities[socialTest.tested_identity.id];

    const numOfEvents = socialTest &&(Object.keys(socialTest.executed_events).length + Object.keys(socialTest.opened_events).length);

    const template = socialTest
        && socialTest.template

    const templateSocialAccount = template && template.social_account;

    // console.log("social test associated with this modal", socialTest, "social object", myEntity.cycles[cycleIdToUse].social, "testId", testId)
    // console.log("social test foudn using testObj", testObj, "testId", testId, "resulting socialTest", socialTest, "social object", myEntity.cycles[cycleIdToUse].social, "social test identities", identity, socialTest.tested_identity, socialTest.tested_identity.id)

    return(
        <div>
            <IconButton onClick={()=> setOpen(true)}
                         variant={"contained"}
                         color={"primary"}>
            <Tooltip  title={`This test had ${numOfEvents} events.`}>
                <Badge badgeContent={numOfEvents}
                       color={"primary"}>
                    <BBIconQuickViewMagnifying
                        style={{color: "black"}}/>
                </Badge>
            </Tooltip>
        </IconButton>

            <Dialog open={open}
                    fullScreen={false}
                    fullWidth={true}
                    maxWidth={"xl"}
                    className={"m-1 p-1 animated fadeIn animation-duration-7"}
                    aria-labelledby="form-dialog-title">

                <DialogTitle id="customized-dialog-title" >
                    <Row>
                        <Col lg={11}/>
                        <Col lg={1} className={"text-right align-self-center d-print-none"}>
                            <IconButton
                                onClick={()=>setOpen(false)}
                                className={"close"}>
                                <CloseIcon/>
                            </IconButton>
                        </Col>
                    </Row>
                </DialogTitle>

                <DialogContent>

                    {socialTest && <div>
                        <Card className={"p-0 m-0"}>
                            <div>
                                <div className={"card-header"}>
                                    <Row className={"card-title text-center"}>
                                        <Col lg={11}>
                                            <h1>{identity && identity.first ? identity.first : "--"} {identity && identity.last? identity.last : "--"}</h1>
                                        </Col>
                                        <Col className={"close"}>
                                            <IdentityScopeToggle identityId={ identity && identity.id} className={"m-0 p-0 align-self-center d-inline"}/>
                                        </Col>
                                    </Row>
                                    <Row className={"text-center"}>
                                        <Col className={"border-right border-gray"}>
                                            {identity && identity.email ? identity.email : "--"}
                                        </Col>
                                        <Col className={"border-right border-gray"}>
                                            {identity && identity.position ? identity.position : ""}
                                        </Col>
                                        <Col>
                                            {identity && identity.created_datetime ? bbFormattedDateString(identity.created_datetime, "shortFullMonth") : "--"}
                                        </Col>
                                    </Row>
                                </div>


                                <Row className={"text-center m-1 p-1"}>
                                    <Col>
                                        Sent From:
                                    </Col>

                                    <Col>
                                        Email Address:
                                    </Col>

                                    <Col>
                                        Email Subject:
                                    </Col>

                                    <Col>
                                        Sent On:
                                    </Col>

                                    <Col>
                                        Type:
                                    </Col>
                                </Row>
                                <Row className={"text-center m-1 p-1"}>
                                    <Col>
                                        {templateSocialAccount.sender_name ? templateSocialAccount.sender_name : "--"}
                                    </Col>

                                    <Col>
                                        {templateSocialAccount.email ? templateSocialAccount.email : "--"}
                                    </Col>

                                    <Col>
                                        {template.subject ? template.subject : "--"}
                                    </Col>

                                    <Col>
                                        {socialTest.sent_datetime ? bbFormattedDateString(socialTest.sent_datetime, "shortFullMonth") : '--'}
                                    </Col>

                                    <Col>
                                        {template.file_payload && <div className={"m-0 p-0 align-self-center"}>
                                            <BBIconPaperClipThin className={"m-0 p-0 align-self-center"}/>
                                            <p>
                                                <small>
                                                    Attachment
                                                </small>
                                            </p>
                                        </div>}
                                        {template.link_payload && <span className={"m-0 p-0 align-self-center"}>
                                            <BBIconHyperlink className={"m-0 p-0 align-self-center"}/>
                                            <p>
                                                <small>
                                                    Link
                                                </small>
                                            </p>
                                        </span>}
                                    </Col>
                                </Row>
                            </div>
                        </Card>
                                <br/>
                        {numOfEvents > 0
                            ? <BRSocialTestEventsTable events={socialTest.opened_events.concat(socialTest.executed_events)}/>
                            : <div>

                            </div>}




                    </div>}




                </DialogContent>
                <DialogActions>
                    <Col lg={12}>
                        <Button onClick={()=>setOpen(false)}
                                variant="contained" color="primary"
                                style={{float: "right"}}>
                            Cancel
                        </Button>
                    </Col>
                </DialogActions>

            </Dialog>


        </div>
    )
}

export default BRSocialTestEventsModal;